import * as LucideIcons from 'lucide-react';
import { benefits } from '../data/mock';

export const BenefitsSection = () => {
  return (
    <section className="section-dark wood-bg">
      <div className="container">
        {/* Section Header */}
        <div className="text-center mb-12">
          <span 
            className="inline-block px-4 py-2 rounded-full mb-4 font-display text-sm uppercase tracking-widest"
            style={{ 
              background: 'rgba(212, 168, 75, 0.15)',
              border: '1px solid var(--border-gold)',
              color: 'var(--gold-primary)'
            }}
          >
            Why Choose Laser?
          </span>
          <h2 className="heading-1 text-gold mb-4">
            The Smart Choice for Wood Borer Treatment
          </h2>
          <p 
            className="body-large max-w-2xl mx-auto"
            style={{ color: 'var(--text-muted)' }}
          >
            Revolutionary technology that does what traditional pest control simply cannot.
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {benefits.map((benefit, index) => {
            const IconComponent = LucideIcons[benefit.icon];
            return (
              <div 
                key={index} 
                className="card-wood"
              >
                <div 
                  className="w-14 h-14 rounded-lg flex items-center justify-center mb-4"
                  style={{ 
                    background: 'linear-gradient(135deg, var(--gold-dark), var(--gold-primary))'
                  }}
                >
                  {IconComponent && (
                    <IconComponent 
                      size={28} 
                      style={{ color: 'var(--bg-dark)' }} 
                    />
                  )}
                </div>
                <h3 
                  className="heading-3 mb-3"
                  style={{ color: 'var(--gold-primary)' }}
                >
                  {benefit.title}
                </h3>
                <p 
                  className="body-small"
                  style={{ color: 'var(--text-muted)' }}
                >
                  {benefit.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
